import { PurchaseOrderLineStatusItem } from './purchase-order-line-status-item';
import { PurchaseOrderAllocation } from './purchase-order-allocation';
import { PurchaseOrderPurchaseAllocation } from './purchase-order-purchase-allocation';

export interface PurchaseOrderLineDetails {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  purchaseContractLineId: string;
  purchaseContractNumber: number;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  sequence: number;
  productId: string;
  productKey: string;
  productDescription: string;
  currencySymbol: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  supplierLineRef: string;
  quantity: number;
  price: number;
  noOfItems: number;
  deliveryWeek: number;
  deliveryDate: Date;
  supplierNotes: string;
  internalNotes: string;
  purchaseOrderStatusId: string;
  deliveryPeriodId: string;
  deliveryMonthId: string;
  deliveryYear: number;
  ourRef1: string;
  ourRef2: string;
  ourRef3: string;
  nextDayDelivery: boolean;
  urgent: boolean;
  makeUpId: string;
  deliveryNotes: string;
  regainCondition: number;
  quantityReceived: number;
  balance: number;
  contractDetails: string;
  currencyCode: string;
  standardRollLength: number;
  warehouseId: string;
  nearestEighth: boolean;
  eta: Date;
  promisedDate: Date;
  callOffReady: boolean;
  callOffRequested: boolean;
  allocatedSalesOrder: string;
  allocatedCustomerOrderReference: string;
  trackingNumber: string;
  replenishmentOrder: string;

  purchaseOrderLineStatusItems: PurchaseOrderLineStatusItem[];
  purchaseOrderAllocations: PurchaseOrderAllocation[];
  purchaseOrderPurchaseAllocations: PurchaseOrderPurchaseAllocation[];
}
